export * from './lib/icon-picker.module';
